// Veego vehicle-tax figures via the details.autospy.ee proxy.

import { detailsApiToken } from './http';
import { sanitizeRegistration } from './checkVehicle';
import { secureFetchJson } from '../security/secureFetch';

// The live proxy nests the figures ({ tax: { registration, yearly }, full_response: {...} });
// the guide documents flat { annual_tax, registration_tax }. Accept both.
export interface CarTaxResponse {
  annual_tax?: number | null;
  registration_tax?: number | null;
  tax?: {
    registration?: string | number | null;
    yearly?: string | number | null;
  } | null;
  full_response?: {
    annual_tax?: number | null;
    registration_tax?: number | null;
  } | null;
}

export interface CarTaxFigures {
  annualTax: number | null;
  registrationTax: number | null;
}

function toNumber(value: string | number | null | undefined): number | null {
  if (typeof value === 'number' && Number.isFinite(value)) return value;
  if (typeof value === 'string' && value.trim()) {
    const parsed = Number(value);
    if (Number.isFinite(parsed)) return parsed;
  }
  return null;
}

export function extractCarTax(response: CarTaxResponse): CarTaxFigures {
  return {
    annualTax:
      toNumber(response.annual_tax) ??
      toNumber(response.full_response?.annual_tax) ??
      toNumber(response.tax?.yearly),
    registrationTax:
      toNumber(response.registration_tax) ??
      toNumber(response.full_response?.registration_tax) ??
      toNumber(response.tax?.registration),
  };
}

export async function fetchCarTax(
  plate: string,
  options: { signal?: AbortSignal } = {},
): Promise<CarTaxResponse> {
  return secureFetchJson<CarTaxResponse>('/car-tax', {
    query: { regnr: sanitizeRegistration(plate) },
    signal: options.signal,
    timeoutMs: 30_000,
    label: 'Car tax',
    legacyToken: detailsApiToken(),
  });
}
